<template>
  <div class="phonePage03" :style="bg">
    <div class="pt_text">
      {{ $tools.localStorageFn.get("PAGE_DATE").field.synopsis }}
    </div>
    <van-swipe class="my-swipe" :autoplay="0" indicator-color="white" @change="onChange" :show-indicators="false"
      ref="indicator">
      <van-swipe-item v-for="(item, index) in 2" :key="index">
        <div class="pbs_item" v-for="ele in $tools.localStorageFn
          .get('PAGE_DATE')
          .field.fieldList.slice(index * 6, (index + 1) * 6)" :key="ele.id" @click="() => {
    $router.push('/mobileAreaExpertiseDetail?id=' + ele.id);
  }
    ">
          <div class="pbs_icon"><img :src="imgUrl + ele.logo" alt="" /></div>
          <div class="pbs_text">{{ ele.name }}</div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="custom-indicator">
      <div class="pt_point" v-for="(item, index) in 2" :key="index" :class="current == index ? 'pt_point_active' : ''"
        @click="() => {
          $refs.indicator.swipeTo(index);
        }
          "></div>
    </div>
    <div class="pb_btn" @click="() => {
      $router.push('/mobileAreaExpertise');
    }
      ">
      查看更多业务领域 >
    </div>
    <floatService style="position: absolute;"></floatService>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: {
        background:
          "url(" +
          this.$tools.localStorageFn.get("PAGE_DATE").banner2 +
          ") no-repeat center center",
      },
      iconList: [
        {
          list: [
            {
              id: "0001",
              label: "公司法律事务",
              src: require("@/assets/images/icon_gsflsw.png"),
            },
            {
              id: "0002",
              label: "民事争议调解与诉讼",
              src: require("@/assets/images/icon_mszytjyss.png"),
            },
            {
              id: "0003",
              label: "行政法律事务",
              src: require("@/assets/images/icon_xzflsw.png"),
            },
            {
              id: "0004",
              label: "医药健康法律",
              src: require("@/assets/images/icon_yyjkfl.png"),
            },
            {
              id: "0005",
              label: "债务重组",
              src: require("@/assets/images/icon_zwcz.png"),
            },
            {
              id: "0006",
              label: "刑事辩护与风险防范",
              src: require("@/assets/images/icon_xsbhyfxff.png"),
            },
          ],
        },
        {
          list: [
            {
              id: "0007",
              label: "项目投资与并购",
              src: require("@/assets/images/icon_xmtzybg.png"),
            },
            {
              id: "0008",
              label: "环境保护与资源开发",
              src: require("@/assets/images/icon_hjbhyzykf.png"),
            },
            {
              id: "0009",
              label: "公益法律服务",
              src: require("@/assets/images/icon_gyflfw.png"),
            },
            {
              id: "0010",
              label: "娱乐与传媒",
              src: require("@/assets/images/icon_ylycm.png"),
            },
            {
              id: "0011",
              label: "知识产权",
              src: require("@/assets/images/icon_zscq.png"),
            },
            {
              id: "0012",
              label: "金融私募与风险投资",
              src: require("@/assets/images/icon_jrsmyfxtz.png"),
            },
          ],
        },
      ],
      current: 0,
    };
  },
  methods: {
    // 轮播变化
    onChange(index) {
      this.current = index;
    },
  },
};
</script>

<style lang="scss">
.phonePage03 {
  height: 100%;
  width: 100%;
  // background: url(~@/assets/images/phoneBg03.png) no-repeat center center;
  background-size: cover !important;
  position: relative;
  padding: 15.45vh 2.5rem 0 2.2rem;
  overflow: hidden;

  .pt_text {
    transform: translateY(-5.0rem);
    opacity: 0;
    transition: 1s 0.5s;
    font-size: 3.2rem;
    font-family: JingZhe_XiaoWei;
    font-weight: 400;
    color: #fff;
    text-align: center;
    margin-bottom: 4.88vh;
  }

  .my-swipe {
    transform: translateY(8.0rem);
    opacity: 0;
    transition: 1s 0.8s;
    overflow: hidden;
    position: relative;

    .van-swipe-item {
      display: flex;
      flex-wrap: wrap;
      padding-top: 3.9rem;

      .pbs_item {
        width: calc(100% / 3);
        margin-bottom: 3.9rem;

        .pbs_icon {
          width: 3.3rem;
          height: 3.3rem;
          margin: 0 auto;
          margin-bottom: 1.2rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .pbs_text {
          text-align: center;
          font-size: 1.1rem;
          font-family: SimHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 1.3rem;
        }
      }
    }
  }

  .custom-indicator {
    display: flex;
    justify-content: center;
    margin-bottom: 3.4rem;

    //   position: absolute;
    //   bottom: -4.6rem;
    //   left: 50%;
    //   transform: translateX(-50%);
    .pt_point {
      width: 0.9rem;
      height: 0.9rem;
      background: #c8c8c8;
      border-radius: 0.4rem;
      margin-right: 0.7rem;
    }

    .pt_point_active {
      width: 2.9rem;
      height: 0.9rem;
      background: #eeeeee;
      border-radius: 0.4rem;
    }
  }

  .pb_btn {
    transform: translateY(8.0rem);
    opacity: 0;
    transition: 1s 1s;
    margin: 0 auto;
    width: 21.1rem;
    height: 3.4rem;
    background: rgba(1, 48, 96, 0);
    border: 0.1rem solid #ffffff;
    font-size: 1.2rem;
    font-family: SimHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 3.4rem;
    text-align: center;
  }
}

.active {
  .phonePage03 {
    .pt_text {
      transform: translate(0);
      opacity: 1;
    }

    .my-swipe {
      transform: translate(0);
      opacity: 1;
    }

    .pb_btn {
      transform: translate(0);
      opacity: 1;
    }
  }
}
</style>